import httpClientService from '../httpClientService';

export default {
	addDataFieldDbIndex: (dataField) =>
		httpClientService.Post(
			'/ProjectSettingsModule/api/DataFieldDbIndexes',
			dataField
		),
	removeDataFieldDbIndex: (dataField) =>
		httpClientService.Delete(
			'/ProjectSettingsModule/api/DataFieldDbIndexes',
			dataField
		),

	getDataFields: () =>
		httpClientService.Get('/ProjectSettingsModule/api/DataFields'),
	getDataFieldsByEntityId: (entityId) =>
		httpClientService.Get(
			`/ProjectSettingsModule/api/DataFields?entityId=${entityId}`
		),

	getEntities: () =>
		httpClientService.Get('/ProjectSettingsModule/api/Entities'),
	getEntityById: (entityId) =>
		httpClientService.Get(`/ProjectSettingsModule/api/${entityId}`),
	addEntity: (entity) =>
		httpClientService.Post('/ProjectSettingsModule/api/Entities', entity),

	getReferenceListTypes: () =>
		httpClientService.Get('/ProjectSettingsModule/api/ReferenceListTypes'),
	getReferenceListTypeById: (id) =>
		httpClientService.Get(
			`/ProjectSettingsModule/api/ReferenceListTypes/${id}`
		),
	addReferenceListType: (data) =>
		httpClientService.Post(
			'/ProjectSettingsModule/api/ReferenceListTypes',
			data
		),
	updateReferenceListType: (data) =>
		httpClientService.Put(
			`/ProjectSettingsModule/api/ReferenceListTypes/${data.Id}`,
			data
		),
	removeReferenceListType: (id) =>
		httpClientService.Delete(
			`/ProjectSettingsModule/api/ReferenceListTypes/${id}`
		),

	getReferenceListValues: () =>
		httpClientService.Get('/ProjectSettingsModule/api/ReferenceListValues'),
	getReferenceListValuesByTypeId: (referenceListTypeId) =>
		httpClientService.Get(
			`/ProjectSettingsModule/api/ReferenceListValues?typeId=${referenceListTypeId}`
		),
	getReferenceListValueById: (id) =>
		httpClientService.Get(
			`/ProjectSettingsModule/api/ReferenceListValues/${id}`
		),
	reorderReferenceListValues: (data) =>
		httpClientService.Post(
			'/ProjectSettingsModule/api/ReferenceListValues/ReorderValues',
			data
		),
	addReferenceListValue: (data) =>
		httpClientService.Post(
			'/ProjectSettingsModule/api/ReferenceListValues',
			data
		),
	updateReferenceListValue: (data) =>
		httpClientService.Put(
			`/ProjectSettingsModule/api/ReferenceListValues/${data.Id}`,
			data
		),
	removeReferenceListValue: (id) =>
		httpClientService.Delete(
			`/ProjectSettingsModule/api/ReferenceListValues/${id}`
		),

	getMergeCondition: (id) =>
		httpClientService.Get(
			`/ProjectSettingsModule/api/MergeConditions/${id}`
		),
	removeMergeConditionField: (id) =>
		httpClientService.Delete(
			`/ProjectSettingsModule/api/MergeConditionFields?id=${id}`
		),
	addMergeConditionField: (item) =>
		httpClientService.Post(
			'/ProjectSettingsModule/api/MergeConditionFields',
			item
		),

	getSettings: () =>
		httpClientService.Get(`/ProjectSettingsModule/api/Settings`),
	updateSettings: (item) =>
		httpClientService.Post(`/ProjectSettingsModule/api/Settings`, item),

	getDefaultGridViewForEntity: (id) =>
		httpClientService.Get(
			`/ProjectSettingsModule/api/GridViews?entityId=${id}`
		),
	getGridViews: () =>
		httpClientService.Get('/ProjectSettingsModule/api/GridViews/Grids'),

	getGridViewConnectorFilters: () =>
		httpClientService.Get(
			'/ProjectSettingsModule/api/GridViewConnectorFilters'
		),
	getGridViewConnectorFiltersByConnector: (connector) =>
		httpClientService.Get(
			`/ProjectSettingsModule/api/GridViewConnectorFilters?gridViewConnectorId=${connector.Id}`
		),
	getGridViewConnectorFiltersById: (id) =>
		httpClientService.Get(
			`/ProjectSettingsModule/api/GridViewConnectorFilters/${id}`
		),
	addGridViewConnectorFilters: (data) =>
		httpClientService.Post(
			'/ProjectSettingsModule/api/GridViewConnectorFilters',
			data
		),
	updateGridViewConnectorFilters: (data) =>
		httpClientService.Put(
			`/ProjectSettingsModule/api/GridViewConnectorFilters/${data.Id}`,
			data
		),
	deleteGridViewConnectorFilters: (data) =>
		httpClientService.Delete(
			`/ProjectSettingsModule/api/GridViewConnectorFilters/${data.Id}`
		),

	getGridViewConnectorHeaders: () =>
		httpClientService.Get(
			'/ProjectSettingsModule/api/GridViewConnectorHeaders'
		),
	getGridViewConnectorHeadersByConnector: (connector) =>
		httpClientService.Get(
			`/ProjectSettingsModule/api/GridViewConnectorHeaders?gridViewConnectorId=${connector.Id}`
		),
	getGridViewConnectorHeadersById: (id) =>
		httpClientService.Get(
			`/ProjectSettingsModule/api/GridViewConnectorHeaders/${id}`
		),
	addGridViewConnectorHeaders: (data) =>
		httpClientService.Post(
			'/ProjectSettingsModule/api/GridViewConnectorHeaders',
			data
		),
	updateGridViewConnectorHeaders: (data) =>
		httpClientService.Put(
			`/ProjectSettingsModule/api/GridViewConnectorHeaders/${data.Id}`,
			data
		),
	deleteGridViewConnectorHeaders: (data) =>
		httpClientService.Delete(
			`/ProjectSettingsModule/api/GridViewConnectorHeaders/${data.Id}`
		),

	getGridViewConnectors: () =>
		httpClientService.Get('/ProjectSettingsModule/api/GridViewConnectors'),
	getGridViewConnectorsById: (id) =>
		httpClientService.Get(
			`/ProjectSettingsModule/api/GridViewConnectors/${id}`
		),
	getGridViewConnectorByGridViewId: (id) =>
		httpClientService.Get(
			`/ProjectSettingsModule/api/GridViewConnectors/ConnectorsByGridViewId/${id}`
		),
	addGridViewConnectors: (data) =>
		httpClientService.Post(
			'/ProjectSettingsModule/api/GridViewConnectors',
			data
		),
	updateGridViewConnectors: (data) =>
		httpClientService.Put(
			`/ProjectSettingsModule/api/GridViewConnectors/${data.Id}`,
			data
		),
	deleteGridViewConnectors: (id) =>
		httpClientService.Delete(
			`ProjectSettingsModule/api/GridViewConnectors?id=${id}`
		),
};
